<div class="layout-content">
	<div class="grid">
		<div class="col-12 pt-0">
			<p-table
				#tableUserFilesList
				dataKey="id"
				[value]="files"
				[lazy]="true"
				(onLazyLoad)="loadFiles($event)"
				[paginator]="true"
				[totalRecords]="totalRecords"
				[loading]="filesLoading"
				[rows]="pageSize"
				[showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true"
				sortField="name" [sortOrder]="1"
				responsiveLayout="stack">

				<ng-template pTemplate="header">
				<tr>
					<th>
						<div pSortableColumn="name" class="flex align-items-center justify-content-center">
							{{ 'NAME' | translate }}
							<p-sortIcon field="name"></p-sortIcon>
						</div>
					</th>
					<th>
						<div pSortableColumn="updated_at" class="flex align-items-center justify-content-center">
							{{ 'UPLOAD_AT' | translate }}
							<p-sortIcon field="updated_at"></p-sortIcon>
						</div>
					</th>
					<th>
					</th>
				</tr>
				</ng-template>
				<ng-template pTemplate="body" let-file>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>{{file.Name}}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'UPLOAD_AT' | translate }}</span>{{file.UpdatedAt | localizedDate: 'medium'}}
						</td>
						<td>
							<span class="p-column-title font-semibold"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'DOWNLOAD' | translate }}"
									tooltipPosition="bottom" icon="pi cm-download" size="large"
									(click)="download(file)" [rounded]="false" [text]="true" severity="primary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate }}"
									tooltipPosition="bottom" icon="pi cm-trash" size="large"
									(click)="delete(file)" [rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
		<div class="col-12" *ngIf="!impersonating()">
			<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="simpleInputTextLayout('borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">
					{{ 'FILE_UPLOAD' | translate }}
					<p-button icon="pi cm-help-1" 
						pTooltip="{{ 'FILES_DIALOG_TOOLTIP' | translate }}" 
						tooltipPosition="right" tooltipEvent="focus"
						class="ml-2"
						styleClass="surface-900 text-color">
					</p-button>
				</div>
				<div class="flex align-items-end justify-content-center" [ngClass]="simpleInputTextLayout('borderInput')">
					<p-fileUpload *ngIf="!reuploadButton && !showUploadButton" mode="basic"
						chooseLabel="{{ 'FILE_UPLOAD' | translate }}"
						type="file"
						(onSelect)="handleFileInput($event)"
						[ngClass]="dynamicInputTextWidth()"
						styleClass="pr-6 {{dynamicInputTextWidth()}}">
					>
					</p-fileUpload>
					<div *ngIf="showUploadButton" class="flex align-items-center text-blue-900">
						<div class="mr-2">{{ labelFile }}</div>
						<button
							type="upload" pButton pRipple
							icon="pi cm-upload" (click)="onUploadClick()"
							label="{{ 'FILE_UPLOAD' | translate }}"
							class="p-button-primary font-normal border-noround-bottom">
						</button>
					</div>
					<button *ngIf="reuploadButton" pButton pRipple type="button"
						id="custom-email-permission-upload-cancel" label="{{ 'UPLOAD_OTHER_FILES' | translate }}"
						icon="pi cm-plus" class="p-button-primary p-button-text border-noround-bottom" size="small"
						(click)="setReupload()">
					</button>
				</div>
			</div>
		</div>
        <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl" *ngIf="impersonating()">
            <p-tag icon="pi cm-alert" [value]="('CANNOT_UPLOAD_WHILE_IMPERSONATING' | translate)" severity="warning"></p-tag>
        </div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="confDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>
